import PropTypes from 'prop-types';
import '../../content/assets/vendor/fontawesome/css/all.min.css';
import '../../content/assets/vendor/bootstrap/css/bootstrap.min.css';
import '../../content/assets/css/style-min.css';
import '../../content/assets/vendor/datetimepicker/jquery.datetimepicker.css';
import '../../content/style.css';

const Bare = (props) => {
  const { children } = props;

  return (
    <div className="main-content" style={{ width: '100%', marginLeft: 0 }}>
      <div className="inner" style={{ marginLeft: 15 }}>{children}</div>
    </div>
  );
};

Bare.propTypes = {
  children: PropTypes.node
};

export default Bare;
